<template>
  <div class="page-add">
    <div class="add-title">期刊详情</div>
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="100px"
    >
      <el-row>
        <el-col>
          <el-form-item label="期刊名称：">
            <el-input readonly v-model="form.periodicalName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="期刊来源：">
            <el-input readonly v-model="form.periodicalSource"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="期刊封面：">
            <div
              id="video-output"
              @mouseenter="showCover = true"
              @mouseleave="showCover = false"
            >
              <img :src="form.coverUrl" class="avatar" />
              <div v-show="showCover" class="cover-bg">
                <i
                  class="el-icon-zoom-in delete"
                  @click.stop="showViewer = true"
                ></i>
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="期刊栏目：">
            <el-input readonly v-model="form.periodicalSubjectsName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="最新期次：">
            <el-input readonly v-model="form.latestPeriodicalPeriod"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="form-handle text-center" label-width="0">
            <back-button :pathOptions="pathOptions" :floatLeft="false" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-image-viewer
      v-if="showViewer"
      :on-close="
        () => {
          showViewer = false;
        }
      "
      :url-list="[form.coverUrl]"
    />
  </div>
</template>

<script>
import { getPeriodicalInfoInfo } from "@/api/periodicalInfo";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import BackButton from "@/components/backButton/index.vue";

export default {
  components: { ElImageViewer, BackButton },
  data() {
    return {
      pathOptions: {
        path: "/periodicalInfo",
      },
      form: {
        periodicalName: "",
        periodicalSource: "",
        coverUrl: "",
        periodicalSubjectsName: "",
        latestPeriodicalPeriod: "",
      },
      showCover: false,
      showViewer: false,
    };
  },
  created() {
    if (this.$route.query.id) {
      getPeriodicalInfoInfo({ uuid: this.$route.query.id }).then((res) => {
        if (!res || res.code != 0) return;
        this.form = res.data;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
$textSize: 12px;
@mixin text {
  color: $textColor;
  font-size: $textSize;
}
/deep/ .scale .el-input {
  @include text;
}

#video-output {
  width: 280px;
  height: 160px;
  position: relative;
  .avatar {
    width: 280px;
    height: 160px;
    display: block;
    object-fit: cover;
  }
  .cover-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(1, 1, 1, 0.5);
    z-index: 199;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    color: #ffffff;
    .delete {
      font-size: 20px;
      cursor: pointer;
    }
  }
}
</style>
